import { useCallback, useEffect, useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useLang } from "../../common/hooks/useLang";
import { NAMESPACE_REMOTE } from "../../common/translations/TranslationHelper";
import { DefaultLoadingIndicator } from "../app/LoadingIndicator";
import ProductHelper from "../products/ProductHelper";

export default function BasicInfos(props) {
  const { currentLanguage } = useLang();
  const { t } = useTranslation(NAMESPACE_REMOTE);

  let [searchParams] = useSearchParams();
  let treeItemKey = searchParams.get("id");
  const truncate = useCallback((text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength - 1) + "…" : text;
  }, []);

  const [breadcrumb, setBreadcrumb] = useState();
  useEffect(() => {
    let result = "";

    const filteredProducts = ProductHelper.getAllParents(props.products, treeItemKey, true).reverse();
    const maxLength = 25;
    for (const product of filteredProducts) {
      if (result !== "") {
        result += " > ";
      }

      result += currentLanguage === "en" ? 
                truncate(product["PARAMETER4"], maxLength) :
                truncate(product["PARAMETER3"], maxLength);
    }

    setBreadcrumb(result);
  }, [props.products, treeItemKey, truncate, currentLanguage]);

  const standardOrders = props.standardOrders;
  const standardOrderId = props.standardOrderId || undefined;
  const customOrderId = props.customOrderId || undefined;
  const orderPriorities = props.orderPriorities;
  const orderPriority = props.orderPriority || undefined;

  const handleStandardOrderChanged = (e) => {
    props.handleStandardOrderChanged(e);
  };

  const handleCustomOrderIdChanged = (e) => {
    props.handleCustomOrderIdChanged(e);
  };

  const handleCustomOrderIdOnBlur = (e) => {
    e.target.value = e.target.value?.trim();
  }

  const handleOrderPriorityChanged = (e) => {
    props.handleOrderPriorityChanged(e);
  };

  return (
    <Container className="p-0" fluid>
      <main>
        <Container fluid="md" className="pt-3">
          <Form.Group as={Row}>
            <Col xs={12} sm={12}>
              <h1 className="h2">{t("TEXT.WSHOP2.CREATE_ORDER.HEADLINE_ORDER_1")}</h1>
              <p className="text-muted fs-80">{t("TEXT.WSHOP2.CREATE_ORDER.HEADLINE_ORDER_2")}</p>
              <p>{breadcrumb}</p>
            </Col>
          </Form.Group>

          { props.isProductsLoading === true && DefaultLoadingIndicator() }
          { props.isProductsLoading === false &&
            <>
              <Form.Group as={Row}>
                <Col xs={12} xl={9}>
                  <Row className="align-items-center mb-3">
                    <Col xs={12} md={4}>
                      <Form.Label>{t("PROMPT.WSHOP2.CREATE_ORDER.STANDARD_ORDER")}*</Form.Label>
                    </Col>
                    <Col xs={12} md={8}>
                      <Form.Select
                        value={standardOrderId}
                        onChange={(e) => handleStandardOrderChanged(e)}
                      >
                        <option key="blankChoice" hidden value></option>
                        {standardOrders.map((p1) => {
                          return (
                            <option key={p1["PSTA_ID"]} value={p1["PARAMETER2"]}>
                              {currentLanguage === "en" ? p1["PARAMETER4"] : p1["PARAMETER3"]}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Col>
                  </Row>
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Col xs={12} xl={9}>
                  <Row className="align-items-center">
                    <Col xs={6} sm={6} md={12}>
                      <Row className="align-items-center mb-3">
                        <Col xs={12} sm={12} md={4}>
                          <Form.Label>{t("PROMPT.WSHOP2.CREATE_ORDER.ORDER_NUMBER")}*</Form.Label>
                        </Col>
                        <Col xs={12} sm={12} md={8}>
                          <Form.Control
                            defaultValue={customOrderId}
                            required={true}
                            maxLength="240"
                            onChange={(e) => handleCustomOrderIdChanged(e)}
                            onBlur={(e) => handleCustomOrderIdOnBlur(e)}
                          ></Form.Control>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={6} sm={6} md={12}>
                      <Row className="align-items-center mb-3">
                        <Col xs={12} sm={12} md={4}>
                          <Form.Label>{t("PROMPT.WSHOP2.CREATE_ORDER.ORDER_PRIORITY")}*</Form.Label>
                        </Col>
                        <Col xs={12} sm={12} md={8}>
                          <Form.Select
                            value={orderPriority}
                            required={true}
                            onChange={(e) => handleOrderPriorityChanged(e)}
                          >
                            <option key="none"></option>
                            {orderPriorities.map((p1) => {
                              return (
                                <option key={p1["P1"]} value={p1["P1"]}>
                                  {p1["P2"]}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

              </Form.Group>
            </>
          }

        </Container>
      </main>
    </Container>
  );
}